import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsightsInstance: ApplicationInsights | null = null;

const resolveConnectionString = () =>
  process.env.NEXT_PUBLIC_APPLICATIONINSIGHTS_CONNECTION_STRING ||
  process.env.NEXT_PUBLIC_APPINSIGHTS_CONNECTION_STRING ||
  "";

export const isAppInsightsEnabled = () => Boolean(resolveConnectionString());

export const getAppInsightsClient = () => {
  if (typeof window === "undefined") {
    return null;
  }

  if (appInsightsInstance) {
    return appInsightsInstance;
  }

  const connectionString = resolveConnectionString();
  if (!connectionString) {
    return null;
  }

  appInsightsInstance = new ApplicationInsights({
    config: {
      connectionString,
      disableFetchTracking: true,
      disableAjaxTracking: true,
      enableAutoRouteTracking: false,
      samplingPercentage: 100,
    },
  });

  appInsightsInstance.loadAppInsights();

  return appInsightsInstance;
};

export const trackAppInsightsEvent = (
  name: string,
  properties?: Record<string, string>
) => {
  const client = getAppInsightsClient();
  if (!client) {
    return;
  }

  client.trackEvent({ name }, properties);
};
